import PrivacyRoute from "../components/routes/PrivacyRoute";
import messages from "../i18n/messages/en.json";

export default function Page() {
  return <PrivacyRoute locale="en" messages={messages} />;
}
